import React from 'react';

import { Box, Flex, SkeletonText } from '@chakra-ui/react';

import style from './styles/CalculatorCarousel.style';

const CalculatorCarousel = () => {
  const arr = [...Array(15).keys()];

  return (
    <Flex sx={style.root}>
      {arr.map(index => (
        <CarouselItem key={index} />
      ))}
    </Flex>
  );
};

const CarouselItem = () => (
  <Box className="carouselItem">
    <SkeletonText
      noOfLines={1}
      skeletonHeight={'16px'}
      className="skeleton-text"
    />
    <SkeletonText
      noOfLines={1}
      skeletonHeight={'16px'}
      className="skeleton-text"
    />
  </Box>
);

export default CalculatorCarousel;
